import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";

const BlogShowcase = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(
          "https://dev.to/api/articles?username=csituma&per_page=8"
        );
        const data = await response.json();
        setBlogs(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  // Get the latest article for the headline
  const featuredArticle = blogs.length > 0 ? blogs[0] : null;
  const remainingArticles = blogs.length > 0 ? blogs.slice(1) : [];

  return (
    <Container fluid className="py-5 bg-light">
      <Container>
        {/* Newspaper Header */}
        <Row className="mb-4 border-bottom border-dark">
          <Col className="text-center">
            <h1 className="display-4 fw-bold" style={{ fontFamily: "serif" }}>
              THE DEVELOPER CHRONICLE
            </h1>
            <p className="text-muted mb-1">
              {"Vol. 1 Issue " + new Date().getFullYear()}
            </p>
            <p className="text-muted mb-3">
              {new Date().toLocaleDateString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
          </Col>
        </Row>

        {/* Subheader */}
        <Row className="mb-4">
          <Col className="text-center">
            <h2
              className="fw-bold border-bottom border-top py-2"
              style={{ fontFamily: "serif" }}
            >
              My Articles
            </h2>
            <p className="mt-3">
              I am a community moderator at{" "}
              <a
                href="https://dev.to"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                Dev.to
              </a>
              , writing and regulating content with{" "}
              <span className="fw-bold">#react</span>,{" "}
              <span className="fw-bold">#typescript</span>,{" "}
              <span className="fw-bold">#graphql</span>,{" "}
              <span className="fw-bold">#solidity</span>.
            </p>
          </Col>
        </Row>

        {/* Featured Article (Headline) */}
        {featuredArticle && (
          <Row className="mb-5">
            <Col>
              <Card className="border-0 shadow-sm">
                <Row className="g-0">
                  <Col md={7}>
                    <Card.Img
                      src={featuredArticle.social_image}
                      alt={featuredArticle.title}
                      className="rounded-start"
                      style={{ height: "100%", objectFit: "cover" }}
                    />
                  </Col>
                  <Col md={5}>
                    <Card.Body className="d-flex flex-column h-100">
                      <div>
                        <div className="mb-2 text-muted small">
                          FEATURED STORY
                        </div>
                        <Card.Title
                          className="display-6 fw-bold"
                          style={{ fontFamily: "serif" }}
                        >
                          {featuredArticle.title}
                        </Card.Title>
                        <Card.Text className="text-muted mb-2">
                          Published on{" "}
                          {new Date(
                            featuredArticle.published_at
                          ).toDateString()}
                        </Card.Text>
                        <Card.Text
                          className="my-3 border-start ps-3 border-3"
                          style={{ fontSize: "1.1rem" }}
                        >
                          {featuredArticle.description}
                        </Card.Text>
                      </div>
                      <div className="mt-auto">
                        <a
                          href={featuredArticle.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-dark"
                        >
                          Read Full Article
                        </a>
                      </div>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        )}

        {/* Remaining Articles in Newspaper Column Style */}
        <Row>
          {remainingArticles.map((blog, index) => (
            <Col key={blog.id} lg={6} className="mb-4">
              <Card className="h-100 border-0">
                <Row className="g-0">
                  <Col xs={4}>
                    <Card.Img
                      src={blog.social_image}
                      alt={blog.title}
                      className="rounded-start"
                      style={{ height: "100%", objectFit: "cover" }}
                    />
                  </Col>
                  <Col xs={8}>
                    <Card.Body>
                      <Card.Title
                        className="fs-5 fw-bold"
                        style={{ fontFamily: "serif" }}
                      >
                        {blog.title}
                      </Card.Title>
                      <Card.Text className="small text-muted">
                        Published on{" "}
                        {new Date(blog.published_at).toDateString()}
                      </Card.Text>
                      <Card.Text className="small">
                        {blog.description.length > 100
                          ? blog.description.substring(0, 100) + "..."
                          : blog.description}
                      </Card.Text>
                      <a
                        href={blog.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="stretched-link text-decoration-none"
                      >
                        Continue reading →
                      </a>
                    </Card.Body>
                  </Col>
                </Row>
                {index !== remainingArticles.length - 1 && index % 2 === 1 && (
                  <hr className="my-4 border-dark" />
                )}
              </Card>
            </Col>
          ))}
        </Row>

        {/* Newspaper Footer */}
        <Row className="mt-5 pt-3 border-top border-dark">
          <Col className="text-center text-muted small">
            <p>THE DEVELOPER CHRONICLE © {new Date().getFullYear()}</p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default BlogShowcase;
